// Page View Tracking Hook
// Add this to your main layout or App component

// Paths to exclude from tracking
const EXCLUDED_PATHS = ['/admin', '/login', '/api', '/dj-login'];

export const trackPageView = async (path?: string, title?: string) => {
    try {
        const currentPath = path || window.location.pathname;
        const currentTitle = title || document.title;

        // Skip tracking for excluded paths
        if (EXCLUDED_PATHS.some(excluded => currentPath.startsWith(excluded))) {
            return;
        }

        await fetch('/api/track/', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                path: currentPath,
                title: currentTitle,
            }),
        });
    } catch (error) {
        // Silently fail - don't break the app for analytics
        console.debug('Analytics tracking failed:', error);
    }
};

// Auto-track on page load
if (typeof window !== 'undefined') {
    // Track initial page view
    window.addEventListener('load', () => {
        trackPageView();
    });

    // Track navigation changes (for SPA)
    let lastPath = window.location.pathname;
    const observer = new MutationObserver(() => {
        if (window.location.pathname !== lastPath) {
            lastPath = window.location.pathname;
            trackPageView();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

export default trackPageView;
